// extracted by mini-css-extract-plugin
export default {"footer_box":"footer_footer_box__jKtPS","largeFont":"footer_largeFont__k66oI"};